<template>
  <div class="appointment">
    <div class="info">
      <h6>
        Today Appointments <span>{{ count }}</span>
      </h6>
      <h6>
        unconfirmed Appointments <span>{{ unconfirmed }}</span>
      </h6>
    </div>
    <div class="tableInfo">
      <h2 class="tableTitle">Appointment Table :</h2>
      <multiselect
        placeholder="Filter By"
        :show-labels="false"
        :value="value"
        :options="options"
        :searchable="false"
        v-model="value"
        @input="filterBy(value)"
      ></multiselect>
    </div>
    <table class="table table-dark table-responsive-sm">
      <thead class="thead-dark">
        <tr>
          <th scope="col">#</th>
          <th scope="col">name</th>
          <th scope="col">time</th>
          <th scope="col">date</th>
          <th scope="col">email</th>
          <th scope="col">service</th>
          <th scope="col">barber</th>
          <th scope="col">phone</th>
          <th scope="col">Confirm</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(client, key) in filterCilent" :key="key">
          <th scope="row">{{ key + 1 }}</th>
          <td>{{ client[0].name }}</td>
          <td>{{ client[0].time }}</td>
          <td>{{ client[0].date }}</td>
          <td>{{ client[0].email }}</td>
          <td>
            <span v-for="(service, key) in client[0].service" :key="key">
              {{ client[0].service }}</span
            >
          </td>
          <td>{{ client[0].barber }}</td>
          <td>{{ client[0].phone }}</td>
          <td>
            <label
              class="switch"
              :class="{ active: client[0].confirm }"
              @click="[updateClient(client[0], client[1]), checked($event)]"
            >
              <input type="checkbox" class="active" />
              <span class="slider round active"></span>
            </label>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { db } from "../../store/firebase";
import Multiselect from "vue-multiselect";

export default {
  data() {
    return {
      clients: [],
      data: [],
      filterCilent: [],
      isActive: true,
      clientId: null,
      currenttime: "",
      count: 0,
      unconfirmed: 0,
      client: {
        name: null,
        email: null,
        phone: null,
        time: null,
        date: null,
        service: null,
        barber: null,
        id: null,
      },
      value: null,
      options: ["All", "Unconfirmed", "Confirmed", "Today"],
    };
  },
  components: { Multiselect },

  created() {
    setInterval(this.getNow, 1000);
    const today = new Date();

    const date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();

    this.currenttime = date;

    db.collection("clientapp")
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          this.clients.push([doc.data(), doc.id]);
          if (doc.data().date == this.currenttime) {
            this.count++;
          }
          if (
            doc.data().confirm == false &&
            doc.data().date >= this.currenttime
          ) {
            this.unconfirmed++;
          }
        });
      });
    this.filterCilent = this.clients;
    console.log(this.filterCilent);

    this.clients.forEach((value) => {
      console.log(value);
    });
  },

  methods: {
    checked(event) {
      if (event.target.classList.contains("active")) {
        event.target.classList.remove("active");
        this.client.confirm = false;
      } else {
        event.target.parentElement.classList.add("active");
        event.target.classList.add("active");
        this.client.confirm = true;
      }
    },
    updateClient(client, clientId) {
      console.log('1: ',client, '2 :',clientId)
      db.collection("clientapp")
        .doc(clientId)
        .update(this.client)
        .then(function () {
          
          console.log("Transaction successfully committed!");
        })
        .catch(function (error) {
          console.log("Transaction failed: ", error);
        });
      this.client = client;
      this.clientId = clientId;
    },
    filterBy(option) {
      this.filterCilent = this.clients;
      var filters;
      if (option == "All") {
        filters = this.clients;
      }
      if (option == "Today") {
        filters = this.clients.filter(
          (client) => client[0].date == this.currenttime
        );
      }
      if (option == "Unconfirmed") {
        filters = this.clients.filter((client) =>
          Boolean(client[0].confirm != true)
        );
      }
      if (option == "Confirmed") {
        filters = this.clients.filter((client) =>
          Boolean(client[0].confirm == true)
        );
      }
      this.filterCilent = filters;
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style lang="scss" scoped>
@import "../../styles/_varriable.scss";

.appointment {
  &:before {
    background-image: url("../../img/icons/barberBack.svg");
    top: 0;
    content: "";
    right: 0;
    left: 0;
    width: 100%;
    bottom: 0;
    height: 100%;
    display: block;
    position: fixed;
    opacity: 0.2;
    pointer-events: none;
  }

  .info {
    text-align: left;
    top: 0;
    margin-bottom: 50px;
    display: flex;
    h6 {
      color: $light_text;
      font-weight: 400;
      margin-right: 30px;
      span {
        background: $backround_text;
        padding: 0px 5px;
        border-radius: 3px;
      }
    }
  }
  .tableInfo {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    .tableTitle {
      text-align: left;
      color: #fff;
      font-weight: 700;
      margin-bottom: 20px;
    }
    .multiselect {
      width: 200px;
    }
  }

  table {
    // margin: 30px;
    tbody {
      background-color: #454d55;

      tr {
        border-bottom: 2px solid #343b3f;
        background-color: transparent;
      }
    }

    .switch {
      position: relative;
      display: inline-block;
      width: 60px;
      height: 34px;
      margin: 0;
    }

    .switch input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background-color: #ccc;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 26px;
      width: 26px;
      left: 4px;
      bottom: 4px;
      background-color: white;
      -webkit-transition: 0.4s;
      transition: 0.4s;
    }

    .active {
      .slider {
        background-color: #1a1d1f;
      }
    }

    input:focus + .slider {
      box-shadow: 0 0 1px #1a1d1f;
    }
    .active {
      .slider:before {
        -webkit-transform: translateX(26px);
        -ms-transform: translateX(26px);
        transform: translateX(26px);
      }
    }

    /* Rounded sliders */
    .slider.round {
      border-radius: 34px;
    }

    .slider.round:before {
      border-radius: 50%;
    }
  }
}
</style>
